import { useState } from "react";
import styles from "./styles.module.scss";
import { Recomendations } from "./components/Recomendations";
import { Categories } from "./components/Categories";
import { initialCategories } from "./mock";
import { Details } from "./components/Details";

interface ProductLaunchProps {
  showRecomendations?: boolean;
  setShowRecomendations?: (value: boolean) => void;
  showCategories?: boolean;
  setShowCategories?: (value: boolean) => void;
  showDetails?: boolean;
  setShowDetails?: (value: boolean) => void;
}

const ProductLaunch = ({
  showRecomendations,
  setShowRecomendations,
  showCategories,
  setShowCategories,
  showDetails,
  setShowDetails,
}: ProductLaunchProps) => {
  const [productName, setProductName] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProductName(e.target.value);
  };

  const handleAddNewProductTitle = () => {
    setShowCategories(true);
  };

  const handleSelectProductCategory = () => {
    setShowCategories(false);
    setShowDetails(true);
  };

  return (
    <div className={styles.launch}>
      {!showRecomendations && (
        <div className={styles.launch__wrapper}>
          <div className={styles.inptWrapper}>
            <label htmlFor="productLaunchName">Add Product</label>
            <input
              type="text"
              id="productLaunchName"
              placeholder="Enter product name"
              className={styles.inpt}
              onChange={handleInputChange}
            />
            {productName.length > 2 && (
              <button className={styles.add} onClick={handleAddNewProductTitle}>
                add
              </button>
            )}
          </div>
          {!showCategories && !showDetails && (
            <div className={styles.recWrapper}>
              <span className={styles.divider}>or</span>
              <button
                className={styles.recomendation}
                onClick={() => setShowRecomendations(!showRecomendations)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="24"
                  viewBox="0 0 20 24"
                  fill="none"
                >
                  <path
                    d="M9.43617 5.42537C9.55617 5.42537 9.6166 5.35509 9.64703 5.24452C9.95817 3.56709 9.93846 3.5268 11.6862 3.19552C11.8062 3.17537 11.8769 3.10552 11.8769 2.98466C11.8769 2.86423 11.8066 2.79395 11.6857 2.7738C9.94832 2.42237 9.99846 2.38209 9.64703 0.724374C9.61703 0.614231 9.5566 0.543945 9.43617 0.543945C9.31575 0.543945 9.25532 0.614231 9.22489 0.724374C8.87346 2.38209 8.93346 2.42195 7.18617 2.7738C7.0756 2.79352 6.99503 2.8638 6.99503 2.98466C6.99503 3.10509 7.0756 3.17537 7.18575 3.19552C8.93389 3.54695 8.91375 3.56709 9.22489 5.24452C9.25489 5.35509 9.31575 5.42537 9.43617 5.42537ZM4.57446 12.3361C4.76517 12.3361 4.89589 12.2157 4.91603 12.0348C5.27732 9.3528 5.36775 9.3528 8.14017 8.82052C8.32103 8.79052 8.45175 8.66966 8.45175 8.47895C8.45175 8.29809 8.32103 8.1678 8.14017 8.13737C5.36775 7.75595 5.26746 7.66552 4.91603 4.93337C4.89589 4.75252 4.76517 4.6218 4.57446 4.6218C4.3936 4.6218 4.26289 4.75252 4.24275 4.94323C3.91146 7.63509 3.77089 7.62523 1.0186 8.13737C0.837745 8.17766 0.707031 8.29809 0.707031 8.47895C0.707031 8.67995 0.837745 8.79052 1.05846 8.82052C3.79103 9.26237 3.91146 9.33266 4.24275 12.0147C4.26289 12.2157 4.3936 12.3361 4.57446 12.3361ZM11.3845 23.4558C11.6459 23.4558 11.8366 23.2647 11.8867 22.9934C12.5999 17.4892 13.3735 16.6552 18.8176 16.0527C19.0987 16.0227 19.2899 15.8118 19.2899 15.5504C19.2899 15.2889 19.0987 15.0884 18.8176 15.0481C13.3735 14.4455 12.5999 13.6119 11.8867 8.10737C11.8366 7.83609 11.6459 7.65523 11.3845 7.65523C11.123 7.65523 10.9327 7.83609 10.8925 8.10737C10.1793 13.6119 9.39589 14.4455 3.9616 15.0481C3.67017 15.0884 3.47946 15.2894 3.47946 15.5504C3.47946 15.8118 3.67017 16.0227 3.9616 16.0527C9.3856 16.7658 10.139 17.4991 10.8925 22.9934C10.9327 23.2647 11.1235 23.4558 11.3845 23.4558Z"
                    fill="#C8A857"
                  />
                </svg>
                <span>see nyle recommendations</span>
              </button>
            </div>
          )}
          {showCategories && (
            <Categories
              cats={initialCategories}
              setCat={handleSelectProductCategory}
            />
          )}
          {showDetails && <Details />}
        </div>
      )}
      {showRecomendations && <Recomendations back={setShowRecomendations} />}
    </div>
  );
};

export default ProductLaunch;
